import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { initAnalytics, trackPageView } from "./util/analytics";
import Cnct from "./contact/Cnct";
import Prcs from "./process/Prcs";
import HostingPage from "./process/pages/hosting/HostingPage";
import SolutionPage from "./process/pages/solution/SolutionPage";
import ProcessPage from "./process/pages/process/ProcessPage";
import ServicePage from "./process/pages/service/ServicePage";
import Nav from "./main/Nav";
import Footer from "./main/Footer";
import UpgradeHome from "./upgrade/UpgradeHome";
import CompanyStory from "./upgrade/CompanyStory";
import PortfolioDetail from "./upgrade/PortfolioDetail";
import SubscriptionCases from "./upgrade/SubscriptionCases";
import InsightList from "./upgrade/InsightList";
import InsightDetail from "./upgrade/InsightDetail";
import './index.css';

// Nav/Footer 없이 자체 레이아웃을 갖는 페이지들
const LOCALES = ['ko', 'en', 'zh', 'ja', 'vi', 'fil'];

function AppContent() {
  const location = useLocation();
  const isContactPage = location.pathname === '/Cnct';

  // Track page view on route change
  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);
  // 업그레이드 페이지들은 자체 상단바를 갖고 있어 구 Nav/Footer 를 겹쳐 그리면 안 된다.
  const UPGRADE_PATHS = ['/subscription/cases', '/operation/cases', '/grant/cases', '/serp/features', '/terms', '/company', '/insights', '/erp'];
  const isUpgradeHome =
    location.pathname === '/' ||
    UPGRADE_PATHS.includes(location.pathname) ||
    LOCALES.some((locale) =>
      location.pathname === `/${locale}` ||
      UPGRADE_PATHS.some((path) => location.pathname === `/${locale}${path}`)
    ) || location.pathname.startsWith('/company/portfolio/') || LOCALES.some((locale) => location.pathname.startsWith(`/${locale}/company/portfolio/`)) || location.pathname.startsWith('/insights/');

  return (
    <div className={`App ${isContactPage ? 'contact-page' : ''}`}>
      {/* Contact 페이지가 아닐 때만 Nav 렌더링 */}
      {!isContactPage && !isUpgradeHome && <Nav />}
   
      <Routes>
        <Route path="/" element={<UpgradeHome />} />
        {LOCALES.map((locale) => <Route key={locale} path={`/${locale}`} element={<UpgradeHome language={locale} />} />)}
        <Route path="/subscription/cases" element={<SubscriptionCases />} />
        <Route path="/operation/cases" element={<SubscriptionCases mode="operation" />} />
        <Route path="/grant/cases" element={<SubscriptionCases mode="grant" />} />
        <Route path="/serp/features" element={<SubscriptionCases mode="serp" />} />
        <Route path="/terms" element={<SubscriptionCases mode="terms" />} />
        <Route path="/erp" element={<SubscriptionCases mode="erp" />} />
        <Route path="/company" element={<CompanyStory />} />
        <Route path="/company/portfolio/:portfolioId" element={<PortfolioDetail />} />
        {LOCALES.map((locale) => <Route key={`${locale}-subscription`} path={`/${locale}/subscription/cases`} element={<SubscriptionCases language={locale} />} />)}
        {LOCALES.map((locale) => <Route key={`${locale}-operation`} path={`/${locale}/operation/cases`} element={<SubscriptionCases mode="operation" language={locale} />} />)}
        {LOCALES.map((locale) => <Route key={`${locale}-grant`} path={`/${locale}/grant/cases`} element={<SubscriptionCases mode="grant" language={locale} />} />)}
        {LOCALES.map((locale) => <Route key={`${locale}-serp`} path={`/${locale}/serp/features`} element={<SubscriptionCases mode="serp" language={locale} />} />)}
        {LOCALES.map((locale) => <Route key={`${locale}-terms`} path={`/${locale}/terms`} element={<SubscriptionCases mode="terms" language={locale} />} />)}
        {LOCALES.map((locale) => <Route key={`${locale}-company`} path={`/${locale}/company`} element={<CompanyStory language={locale} />} />)}
        {LOCALES.map((locale) => <Route key={`${locale}-portfolio`} path={`/${locale}/company/portfolio/:portfolioId`} element={<PortfolioDetail language={locale} />} />)}
        <Route path="/insights" element={<InsightList />} />
        <Route path="/insights/:insightId" element={<InsightDetail />} />
        <Route path="/Prcs" element={<Prcs />} />
        <Route path="/Cnct" element={<Cnct />} />
        <Route path="/hosting" element={<HostingPage />} />
        <Route path="/solution" element={<SolutionPage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/service" element={<ServicePage />} />
      </Routes>
      
      {/* Contact 페이지가 아닐 때만 Footer 렌더링 */}
      {!isContactPage && !isUpgradeHome && <Footer />}
    </div>
  );
}

function App() {
  // Initialize analytics once on mount
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
